/**
 * Import Section — thin wrapper around ImportsCard.
 */

import { AttioImportCard } from '@/components/attio-import/AttioImportCard';
import { ImportsCard } from '@/components/csv-import/ImportsCard';
import { LightfieldImportCard } from '@/components/lightfield-import/LightfieldImportCard';
import { HubspotImportCard } from '@/lib/integrations/hubspot/components/hubspot-import/HubspotImportCard';
import { useViewHealthMarker } from '@/lib/view-health';

export function ImportSection() {
  useViewHealthMarker('settings-section-ready');
  return (
    <div className='space-y-8'>
      <div>
        <h2 className='text-lg font-semibold text-fg-primary'>Import</h2>
        {/* Deliberately mechanism-agnostic: this page hosts a file upload AND a
            Lightfield connect, so naming only files here is wrong the moment the
            lightfield_import flag is on. Each card below states its own specifics. */}
        <p className='text-sm text-fg-tertiary mt-0.5'>
          Bring your existing records into Ahoy.
        </p>
      </div>
      <div>
        <ImportsCard />
      </div>
      <div>
        <LightfieldImportCard />
      </div>
      <div>
        <AttioImportCard />
      </div>
      <div>
        <HubspotImportCard />
      </div>
    </div>
  );
}
